/**
 * @description 商品政策合规性
 *
 * @props {string} 
 *
 * @slot {插槽} 
 *
 */
<template>
  <div class="product-compliance">
      <div class="title">商品政策合规性</div>
      <div class="main">
        <div class="cell" v-for="(item, index) in complianceList" :key="index">
          <div class="cell-title">{{ item.title }}</div>
          <div v-if="item.openness">
            <div class="cell-item">目标：0次投诉</div>
            <div class="cell-item">{{ item.timeFrameStart }} - {{ item.timeFrameEnd }}</div>
            <div class="cell-item num" :class="{abnormal: !item.completeTarget}">{{ item.count }}</div>
          </div>
          <div v-else class="cell-item">暂未开放</div>
        </div>
      </div>
  </div>
</template>

<script>
import { convertToDate } from "@/utils/date.util"

export default {
  props: {
    commodityPolicies: {
      default: () => ({})
    }
  },
  data() {
    return {
    }
  },
  computed: {
    complianceList() {
      let complianceList = [
        { title: "知识产权投诉", openness: true, timeFrameStart: null, timeFrameEnd: null, count: null, completeTarget: true},
        { title: "商品安全投诉", openness: true, timeFrameStart: null, timeFrameEnd: null, count: null, completeTarget: true},
        { title: "商品真实性投诉", openness: true, timeFrameStart: null, timeFrameEnd: null, count: null, completeTarget: true},
        { title: "上架政策违规", openness: true, timeFrameStart: null, timeFrameEnd: null, count: null, completeTarget: true},
        { title: "商品状况", openness: true, timeFrameStart: null, timeFrameEnd: null, count: null, completeTarget: true },
        { title: "受限商品", openness: true, timeFrameStart: null, timeFrameEnd: null, count: null, completeTarget: true },
        { title: "卖家商品评论", openness: true, timeFrameStart: null, timeFrameEnd: null, count: null, completeTarget: true }
      ]
      if (this.commodityPolicies.intellectualPropertyData) {
        let {timeFrameStart, timeFrameEnd, defectCount, completeTarget} = this.commodityPolicies.intellectualPropertyData
        complianceList[0].timeFrameStart = convertToDate(new Date(timeFrameStart))
        complianceList[0].timeFrameEnd = convertToDate(new Date(timeFrameEnd))
        complianceList[0].count = defectCount
        complianceList[0].completeTarget = completeTarget
      }
      if (this.commodityPolicies.productSafetyData) {
        let {timeFrameStart, timeFrameEnd, defectCount, completeTarget} = this.commodityPolicies.productSafetyData
        complianceList[1].timeFrameStart = convertToDate(new Date(timeFrameStart))
        complianceList[1].timeFrameEnd = convertToDate(new Date(timeFrameEnd))
        complianceList[1].count = defectCount
        complianceList[1].completeTarget = completeTarget
      }
      if (this.commodityPolicies.productAuthenticityData) {
        let {timeFrameStart, timeFrameEnd, defectCount, completeTarget} = this.commodityPolicies.productAuthenticityData
        complianceList[2].timeFrameStart = convertToDate(new Date(timeFrameStart))
        complianceList[2].timeFrameEnd = convertToDate(new Date(timeFrameEnd))
        complianceList[2].count = defectCount
        complianceList[2].completeTarget = completeTarget
      }
      if (this.commodityPolicies.listingPolicyData) {
        let {timeFrameStart, timeFrameEnd, defectCount, completeTarget} = this.commodityPolicies.listingPolicyData
        complianceList[3].timeFrameStart = convertToDate(new Date(timeFrameStart))
        complianceList[3].timeFrameEnd = convertToDate(new Date(timeFrameEnd))
        complianceList[3].count = defectCount
        complianceList[3].completeTarget = completeTarget
      }
      if (this.commodityPolicies.productConditionData) {
        let {timeFrameStart, timeFrameEnd, defectCount, completeTarget} = this.commodityPolicies.productConditionData
        complianceList[4].timeFrameStart = convertToDate(new Date(timeFrameStart))
        complianceList[4].timeFrameEnd = convertToDate(new Date(timeFrameEnd))
        complianceList[4].count = defectCount
        complianceList[4].completeTarget = completeTarget
      }
      if (this.commodityPolicies.productRestrictedPolicyData) {
        let {timeFrameStart, timeFrameEnd, defectCount, completeTarget} = this.commodityPolicies.productRestrictedPolicyData
        complianceList[5].timeFrameStart = convertToDate(new Date(timeFrameStart))
        complianceList[5].timeFrameEnd = convertToDate(new Date(timeFrameEnd))
        complianceList[5].count = defectCount
        complianceList[5].completeTarget = completeTarget
      }
      if (this.commodityPolicies.productReviewsPolicyData) {
        let {timeFrameStart, timeFrameEnd, defectCount, completeTarget} = this.commodityPolicies.productReviewsPolicyData
        complianceList[6].timeFrameStart = convertToDate(new Date(timeFrameStart))
        complianceList[6].timeFrameEnd = convertToDate(new Date(timeFrameEnd))
        complianceList[6].count = defectCount
        complianceList[6].completeTarget = completeTarget
      }
      return complianceList
    }
  }
}
</script>

<style scoped lang="scss">
.abnormal {
  color: #F56C6C !important;
}
.product-compliance {
  padding-bottom: 15px;
  .title {
    line-height: 50px;
    padding-left: 20px;
    border-bottom: 1px solid #eee;
    font-weight: 600;
    font-size: 14px;
    color: #333;
  }
  .main {
    display: flex;
    justify-content: space-around;
    text-align: center;
    line-height: 1;
    padding-top: 20px;
    .cell {
      color: #333;
      &:last-child {
        padding-right: 0;
      }
      .cell-title {
        padding-bottom: 15px;
        font-size: 14px;
        font-weight: 600;
      }
      .cell-item {
        font-size: 12px;
        padding-bottom: 14px;
        &.num {
          font-weight: 600;
          font-size: 15px;
        }
      }
    }
  }
}
</style>